module.exports = __webpack_public_path__ + "static/images/eye-with-cross-dark.85481e40c81695e6b836107878304fd6.svg";